const moment = require('moment');
import {t} from 'l10n'

export function formatDate(guestbookMessage) {
    return moment(guestbookMessage.creation_date).format(t('MM/DD/YYYY [at] HH:mm'))
}


// WEBPACK FOOTER //
// ./src/utils/guestbookMessages.js